"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ants = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const ResourceType_1 = require("../../ResourceType");
const CardName_1 = require("../../CardName");
const AddResourcesToCard_1 = require("../../deferredActions/AddResourcesToCard");
const RemoveResourcesFromCard_1 = require("../../deferredActions/RemoveResourcesFromCard");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
class Ants extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.ANTS,
            tags: [Tags_1.Tags.MICROBE],
            cost: 9,
            resourceType: ResourceType_1.ResourceType.MICROBE,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.oxygen(4)),
            metadata: {
                cardNumber: '035',
                description: 'Requires 4% oxygen.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Remove 1 Microbe from any card to add 1 to this card.', (eb) => {
                        eb.microbes(1).any.startAction.microbes(1);
                    }).br;
                    b.vpText('1 VP per 2 Microbes on this card.');
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.microbes(1, 2),
            },
        });
        this.resourceCount = 0;
    }
    getVictoryPoints() {
        return Math.floor(this.resourceCount / 2);
    }
    play() {
        return undefined;
    }
    canAct(player) {
        if (player.game.isSoloMode())
            return true;
        return RemoveResourcesFromCard_1.RemoveResourcesFromCard.getAvailableTargetCards(player, this.resourceType).length > 0;
    }
    action(player) {
        if (player.isCorporation(CardName_1.CardName.BENTENMARU)) {
            const allTargets = RemoveResourcesFromCard_1.RemoveResourcesFromCard.getAvailableTargetCards(player, ResourceType_1.ResourceType.MICROBE);
            const ownTargets = RemoveResourcesFromCard_1.RemoveResourcesFromCard.getAvailableTargetCards(player, ResourceType_1.ResourceType.MICROBE, true);
            const opponentTargets = allTargets.filter((target) => !ownTargets.includes(target));
            if (opponentTargets.length > 0 || player.game.isSoloMode()) {
                player.game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, ResourceType_1.ResourceType.MICROBE, { filter: (c) => c.name === this.name, count: 2 }));
            }
            return undefined;
        }
        player.game.defer(new RemoveResourcesFromCard_1.RemoveResourcesFromCard(player, ResourceType_1.ResourceType.MICROBE));
        player.game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, ResourceType_1.ResourceType.MICROBE, { filter: (c) => c.name === this.name }));
        return undefined;
    }
}
exports.Ants = Ants;
//# sourceMappingURL=Ants.js.map